/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Replacefiles_Keepboth4Inputs */

const en_coinvestments_dataroom_replacefiles_keepboth4 = /** @type {(inputs: Coinvestments_Dataroom_Replacefiles_Keepboth4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep both`)
};

/**
* | output |
* | --- |
* | "Keep both" |
*
* @param {Coinvestments_Dataroom_Replacefiles_Keepboth4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_replacefiles_keepboth4 = /** @type {((inputs?: Coinvestments_Dataroom_Replacefiles_Keepboth4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Replacefiles_Keepboth4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_replacefiles_keepboth4(inputs)
});
export { coinvestments_dataroom_replacefiles_keepboth4 as "coInvestments_dataRoom_replaceFiles_keepBoth" }